import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  IAttendant,
  IDuplicateAttendanceSession,
  IEventAndSessionData,
  IGetDuplicatesDetailsParams,
} from "../../interfaces/reports.interfaces";
import { AssistanceService } from "src/app/attendanceRecord/services/asistanceService/assistance.service";

@Component({
  selector: "app-duplicate-detail-by-attendant",
  templateUrl: "./duplicate-detail-by-attendant.component.html",
})
export class DuplicateDetailByAttendantComponent implements OnInit {
  @Input()
  public attendant?: IAttendant;
  @Input()
  public eventAndSessionData?: IEventAndSessionData;
  @Output()
  public closeOffCanvasEmitter: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  // data
  public duplicateAttendance: IDuplicateAttendanceSession[] = [];
  // flags
  protected errorOccurred: boolean = false;
  protected isLoading: boolean = false;
  // pagination
  protected page: number = 1;
  protected pageSize: number = 5;

  constructor(private assistanceService: AssistanceService) {}

  ngOnInit(): void {
    this.getDuplicateDetails();
  }

  get collectionSize() {
    return this.duplicateAttendance.length;
  }

  getDuplicateDetails() {
    if (!this.attendant || !this.eventAndSessionData) {
      this.errorOccurred = true;
      return;
    }
    this.isLoading = true;
    const searchParams: IGetDuplicatesDetailsParams = {
      numeroPersona: this.attendant.numeroPersona,
      localizadorId: this.eventAndSessionData.locatorId,
      yearId: this.eventAndSessionData.yearId,
    };
    this.assistanceService
      .getDuplicateDetailByUser(
        this.eventAndSessionData.fkObjectIdExt,
        searchParams
      )
      .subscribe({
        next: sessions => {
          this.duplicateAttendance = sessions;
          this.page = 1;
          this.errorOccurred = false;
          this.isLoading = false;
        },
        error: () => {
          this.duplicateAttendance = [];
          this.errorOccurred = true;
          this.isLoading = false;
        },
      });
  }

  onClose() {
    this.duplicateAttendance = [];
    this.attendant = undefined;
    this.closeOffCanvasEmitter.emit(true);
  }
}
